// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DownloadIcon_wrapper__2o7g7"};